import { MutationTree } from 'vuex';
import { StatisticState, DetailItem, CustomGroupItem } from './types';

export const mutations: MutationTree<StatisticState> = {
  setCustomStatisticDetail: (state, data: DetailItem[]) => state.customStatisticDetail = data,
  pushCustomStatisticDetail: (state, data: DetailItem[]) => state.customStatisticDetail = state.customStatisticDetail.concat(data),
  setCustomStatisticGroup: (state, data: CustomGroupItem[]) => state.customStatisticGroup = data
};